function getIdFromSlug(slug: string) {
  if (!slug) return
  const sections = slug.split('-')
  const maybeId = sections[0]
  if (!maybeId || isNaN(parseInt(maybeId, 10))) return
  return maybeId
}

export default getIdFromSlug
